/* eslint-disable no-nested-ternary */
import { useScroll } from "@/shared/client";
import { MEDIA } from "@/styles/common";
import { getDefaultParameters } from "@/utils";
import { Center, Spinner, Text, VStack } from "@chakra-ui/react";
import styled from "@emotion/styled";
import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import ReactPlayer from "react-player";

export const VimeoPlayer = ({ id }: { id: number }) => {
    const { isMobile, isTablet, isDesktop } = MEDIA();
    const { positionY } = useScroll({ start: isTablet ? "140px" : "180px", end: isTablet ? "100px" : "140px" });
    const [isNewSound, setIsNewSound] = useState(false);
    const [isPlaying, setIsPlaying] = useState(false);
    const [width, setWidth] = useState(window.innerWidth);
    const [newHeight, setNewHeight] = useState(window.innerHeight);

    const { idx } = getDefaultParameters();
    const anotherCase = isDesktop && newHeight > 820 ? width : width;

    useEffect(() => {
        const handleResize = () => {
            setWidth(window.innerWidth);
            setNewHeight(window.innerHeight);
        };

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    useEffect(() => {
        if (!isNewSound) {
            setIsNewSound(false);
        }
    }, []);

    const handleSoundToggle = () => {
        setIsNewSound((prev) => !prev);
    };

    const handleReady = () => {
        setIsPlaying(true);
    };

    return (
        <Wrapper>
            {id !== 0 ? (
                <>
                    {!isPlaying && (
                        <Center position="absolute" w="100vw" h="100vh" gap="4px" background="#000">
                            <VStack color="white" rowGap="24px">
                                <Spinner
                                    color="white"
                                    borderWidth="8px"
                                    style={{
                                        height: "84px",
                                        width: "84px",
                                    }}
                                />
                                <Text>Video Loading...</Text>
                            </VStack>
                        </Center>
                    )}
                    {isMobile && idx === "2017" ? (
                        <ReactPlayer
                            url="https://vimeo.com/1072458279"
                            playing={isPlaying}
                            loop
                            muted={!isNewSound}
                            volume={isNewSound ? 1 : 0}
                            width="100vw"
                            height="100vh"
                            onReady={handleReady}
                            config={{
                                file: {
                                    attributes: {
                                        playsInline: true,
                                    },
                                },
                                vimeo: {
                                    playerOptions: {
                                        responsive: true,
                                        background: true,
                                        playsinline: 1,
                                    },
                                },
                            }}
                            style={{
                                position: "absolute",
                                // transform: "translateX(-7%)",
                                objectFit: "contain",
                            }}
                        />
                    ) : (
                        <ReactPlayer
                            url={`https://vimeo.com/${id}`}
                            playing={isPlaying}
                            loop
                            muted={!isNewSound}
                            volume={isNewSound ? 1 : 0}
                            width={window.innerWidth > 1400 ? anotherCase : "177.77vh"}
                            height="100vh"
                            onReady={handleReady}
                            config={{
                                file: {
                                    attributes: {
                                        playsInline: true,
                                    },
                                },
                                vimeo: {
                                    playerOptions: {
                                        responsive: true,
                                        background: true,
                                        playsinline: 1,
                                    },
                                },
                            }}
                            style={{
                                position: "absolute",
                                top: "0",
                                left: isMobile ? "-50%" : "50%",
                                transform: isMobile ? "translateX(-25%)" : "translateX(-50%)",
                                objectFit: "cover",
                            }}
                        />
                    )}

                    <Center
                        as={motion.div}
                        zIndex="9999"
                        position="fixed"
                        bottom={positionY}
                        animate={{
                            bottom: positionY,
                        }}
                        bgColor="rgba(0,0,0,0.8)"
                        borderRadius={isTablet ? "24px" : "16px"}
                        overflow="hidden"
                        right={isTablet ? "16px" : "48px"}
                        w={isTablet ? "48px" : "72px"}
                        height={isTablet ? "48px" : "80px"}
                    >
                        <Center
                            w="100%"
                            h="100%"
                            background={`url(${process.env.PUBLIC_URL}/assets/sound_${isNewSound ? "on" : "off"}.png) no-repeat center / cover`}
                            bgSize="32px"
                            cursor="pointer"
                            onClick={handleSoundToggle}
                            borderRadius="8px"
                        />
                    </Center>
                </>
            ) : (
                <div>오류</div>
            )}
        </Wrapper>
    );
};

const Wrapper = styled.div`
    position: relative;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    background: black;
`;
